module.exports = __webpack_public_path__ + "static/img/douyin.9d87712d.png";